module.exports = __webpack_public_path__ + "media/images/city/049-medieval-wall-ad0c1a7d955ce125c344114615c598fe.svg";